import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import i18next from "i18next";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import ActionLink from "@mnjsplatform/components/lib/common/ActionLink";
import RequestScheduleVacationCreatePopup from "./RequestScheduleVacationCreatePopup";
import AuthProvider from "@mnjsplatform/data/lib/security/authProvider";
import pathJoin from "@mnjsplatform/data/lib/utils/pathJoin";
import $ from "jquery";

class RequestScheduleVacationList extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            showRequestForm: false,
            rowKey: null
//            inOperation: true
        }
    }

    componentDidMount() {
        this.initialize();
    }

    componentDidUpdate(prevProps) {
        if (this.props.currentYear !== prevProps.currentYear) {
            this.initialize();
        }
    }

    initialize = async () => {
//        this.setState({inOperation: true});
        try {
            await this.props.dispatch(this.props.SchedHolidayTransfer_ListPO.execute({"NumYear": this.props.currentYear}));
        } catch (e) {
            console.error(e);
        } finally {
//            this.setState({inOperation: false});
        }
    }
    createRequest = async () => {
        await this.props.dispatch(this.props.SchedHolidayTransfer_NewPO.execute({"NumYear": this.props.currentYear}));
        await this.props.dispatch(this.props.SchedHolidayTransfer_ListPO.refresh());

        if (!this.props.SchedHolidayTransfer_NewPO.isError) {
            const rowKey = Object.assign({}, this.props.SchedHolidayTransfer_NewPO.getRow(0), {IsForBoss: 0});
            //console.log("rowKey: ", JSON.stringify(rowKey));
            this.setState({
                showRequestForm: true,
                rowKey: rowKey
            })
        }
    }
    selectRow = async (row) => {
        this.setState({
            showRequestForm: true,
            rowKey: Object.assign({}, this.props.SchedHolidayTransfer_ListPO.getRowKey(row), {IsForBoss: 0})
        })
    }
    closeRequestForm = (refresh = false) => {
        this.setState({showRequestForm: false}, async () => {
            if (refresh) {
                await this.props.dispatch(this.props.SchedHolidayTransfer_ListPO.refresh());
            }
        })
    }
    getStatus = (row) => {
        let className;
        switch (row.Status) {
            case 'draft': {
                className = 'badge-secondary';
                break;
            }
            case 'confirm': {
                className = 'badge-success';
                break;
            }
            case 'reject': {
                className = 'badge-danger';
                break;
            }
            case 'send': {
                className = 'badge-primary';
                break;
            }
            default: {
                className = 'badge-secondary';
                break;
            }
        }
        return <span className={"badge badge-pill " + className}>{row.StatusName}</span>
    }
    getDocument = async (row, fieldName) => {
        const token = await AuthProvider.getToken();
        const downloadPath = pathJoin(window.config.apiRoot, "Vacation", "DownloadFile") + "?" + $.param({
            b_token: token,
            id: row.SchedHolidayTransferIntId,
            fieldName: fieldName
        });
        window.open(downloadPath, '_blank');
    }
    renderRow = (rowData) => {
        //const badge = (rowData.row.IsSent === 1 ? null : );
        if (!rowData.row)
            return null;
        return (<tr key={rowData.row.SchedHolidayTransferIntId}>
            <td className="p-1" style={{borderTop: 'none'}}>
                <ActionLink onSelect={async () => {
                    await this.selectRow(rowData.row)
                }}>
                    {rowData.row.AppView}</ActionLink>
                &nbsp;
                {this.getStatus(rowData.row)}
                &nbsp;
                {rowData.row.MsgCmd &&
                    <span className="badge badge-pill badge-dark"><ActionLink onSelect={async () => {
                        await this.getDocument(rowData.row, "MsgCmd")
                    }}>{rowData.row.MsgCmd}</ActionLink></span>
                }
                &nbsp;
                {rowData.row.MsgScan &&
                    <ActionLink onSelect={async () => {
                        await this.getDocument(rowData.row, "MsgScan")
                    }}><span className="badge badge-pill badge-info">{rowData.row.MsgScan}</span>
                    </ActionLink>
                }
                &nbsp;
                {rowData.row.CommentOnReject &&
                    <span className="badge badge-pill badge-warning">{rowData.row.CommentOnReject}</span>
                }
            </td>
        </tr>)
    }

    render() {
        /*
                if(this.state.inOperation)
                    return null;
        */
        return (<>
            <button type="button" className="btn btn-regular -goahead my-2"
                    title={i18next.t("Create_Request_Schedule_Vacation")}
                    onClick={this.createRequest}>
                {i18next.t("Create_Request_Schedule_Vacation")}
            </button>
            {
                this.props.SchedHolidayTransfer_ListPO.rowsCount() === 0 &&
                <div className="my-3">
                    <strong>{i18next.t("Requests_Year_Not_Exists", {year: this.props.currentYear})}</strong>
                </div>
            }
            {
                this.props.SchedHolidayTransfer_ListPO.rowsCount() > 0 &&
                <GridView dataItem={this.props.SchedHolidayTransfer_ListPO} showHeader={false} pageSize={5}
                          allowPagination={true}
                          readOnly={true} activePageSize={5} renderRowEx={this.renderRow}/>
            }
            {
                this.state.showRequestForm &&
                <RequestScheduleVacationCreatePopup rowKey={this.state.rowKey}
                                                    onClose={this.closeRequestForm}
                                                    readOnly={false}/>
            }
        </>);
    }
}

RequestScheduleVacationList.propTypes = {
    dispatch: PropTypes.func.isRequired,
    SchedHolidayTransfer_ListPO: PropTypes.object,
    SchedHolidayTransfer_NewPO: PropTypes.object,
}

RequestScheduleVacationList.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        SchedHolidayTransfer_ListPO: state.vacationState.SchedHolidayTransfer_ListPO,
        SchedHolidayTransfer_NewPO: state.vacationState.SchedHolidayTransfer_NewPO,
    }
}

export default connect(mapStateToProps)(RequestScheduleVacationList);